export const Themes = {
	BASE: 'base',
	TOOLTIP: 'tooltip',
	SELECT: 'select',
} as const;

export type Theme = (typeof Themes)[keyof typeof Themes];
